import styled, { css } from "styled-components";

import { transition } from "@ui/helpers";

const Nav = styled.nav`
  --content-tabs-gap: ${props => props.theme.margins.base_x2};
  --content-tabs-border-size: 1px;
  --content-tabs-border-color: ${props => props.theme.palette.grey100};
  --content-tabs-border-color--active: ${props => props.theme.palette.grey800};
  --content-tabs-padding-sides: ${props => props.theme.margins.half};
  --content-tabs-padding-bottom: ${props => props.theme.margins.half};

  position: relative;
  margin-bottom: ${props => props.theme.margins.base_x1_5};
  padding: 0 var(--content-tabs-padding-sides);
  display: flex;
  align-items: flex-end;
  gap: var(--content-tabs-gap);

  &::after {
    content: "";
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: var(--content-tabs-border-size);
    background-color: var(--content-tabs-border-color);
  }
`;

const buttonStyle = css`
  all: unset;
  position: relative;
  padding-bottom: var(--content-tabs-padding-bottom);
  cursor: pointer;

  &:disabled {
    opacity: 0.5;
    pointer-events: none;
  }

  &::after {
    content: "";
    position: absolute;
    left: calc(var(--content-tabs-padding-sides) * -1);
    bottom: 0;
    width: calc(var(--content-tabs-padding-sides) * 2 + 100%);
    height: var(--content-tabs-border-size);
    background-color: var(--content-tabs-border-color--active);
    transition: ${transition("opacity")};
    opacity: 0;
    z-index: 1;
  }
`;

const Button = styled.button<{
  isActive?: boolean;
}>`
  ${buttonStyle}

  ${props =>
    props.isActive &&
    css`
      font-weight: ${props => props.theme.fonts.weights.semibold};
    `}

  &::after {
    ${props =>
      props.isActive &&
      css`
        opacity: 1;
      `}
  }
`;

const ButtonLink = styled.button`
  ${buttonStyle}

  font-weight: ${props => props.theme.fonts.weights.semibold};
  color: ${props => props.theme.palette.blue500};

  &::after {
    display: none;
  }
`;

export { Nav, Button, ButtonLink };
